const angular = require('angular');
const app = angular.module('learn-directives');

app.directive('suPopup', function () {
  return {
    restrict: "A",
    scope : {
      suPopup : "="
    },
    link: function(scope, element, attrs) {
      var className = '';
      var popupMetaData = scope.suPopup;
      var title = popupMetaData['title'] || '';
      var content = popupMetaData['content'] || '';
      var position = popupMetaData['position'] || 'top';
      var size = popupMetaData['size'] || 'small';
      var allPositions = position.split(' ');

      className = 'ui popup transition visible ' + size + ' ' + position;

      var getElementOffset = function(element) {
        var de = document.documentElement;
        var box = element.getBoundingClientRect();
        var top = box.top + window.pageYOffset - de.clientTop;
        var left = box.left + window.pageXOffset - de.clientLeft;
        return {
          top: top, left: left
        };
      };

      var getElementWidth = function(element) {
        return element.getBoundingClientRect().width;
      };

      var getElementHeight = function(element) {
        return element.getBoundingClientRect().height;
      };

      var getValue = function(item) {
        return parseInt(item.slice(0, -2));
      };

      var totalBox = function(element, items) {
        var total = 0;
        angular.forEach(items, function(item) {
          total += getValue(window.getComputedStyle(element,null).getPropertyValue(item));
        });
        return total;
      };

      //
      // Handle mouse over
      //
      element.bind('mouseover', function(){
        var popupElement = document.createElement('div');
        popupElement.id = 'su-popup';
        popupElement.setAttribute('class', className);

        var titleElement = document.createElement('div');
        titleElement.setAttribute('class', 'header');
        if (title) {
          titleElement.innerHTML = title;      
        }
        popupElement.appendChild(titleElement);

        var contentElement = document.createElement('div');
        contentElement.setAttribute('class', 'content');
        if (content) {
          contentElement.innerHTML = content;      
        }
        popupElement.appendChild(contentElement);

        element[0].appendChild(popupElement);

        popupElement = document.getElementById('su-popup');

        var parent = {
          width: getElementWidth(element[0]),
          height: getElementHeight(element[0]),
          plusRight: totalBox(element[0], ['padding-right', 'margin-right', 'border-right']),
          plusLeft: totalBox(element[0], ['padding-left', 'margin-left', 'border-left']),
          plusTop: totalBox(element[0], ['padding-top', 'margin-top', 'border-top']),
          plusBottom: totalBox(element[0], ['padding-bottom', 'margin-bottom', 'border-bottom'])
        };

        var popupDimensions = {
          width: getElementWidth(popupElement),
          height: getElementHeight(popupElement),
          plusRight: totalBox(popupElement, ['padding-right', 'margin-right', 'border-right']),
          plusLeft: totalBox(popupElement, ['padding-left', 'margin-left', 'border-left']),
          plusTop: totalBox(popupElement, ['padding-top', 'margin-top', 'border-top']),
          plusBottom: totalBox(popupElement, ['padding-bottom', 'margin-bottom', 'border-bottom'])
        };

        var positioning = {
          bottom: 'auto',
          left: 'auto',
          top: 'auto',
          right: 'auto',
          position: 'absolute'
        };

        switch (position) {
          case 'top left':
            positioning.bottom = popupDimensions.height - parent.plusTop + 'px';
            break;
          case 'top center':
            positioning.bottom = popupDimensions.height - parent.plusTop + 'px';
            positioning.left = parent.width/2 - parent.plusLeft + 'px';
            break;
          case 'top right':
            positioning.bottom = popupDimensions.height - parent.plusTop + 'px';
            positioning.left = (-popupDimensions.width + popupDimensions.plusLeft + popupDimensions.plusRight)/2 + parent.width/2 + parent.plusRight + 'px';
            break;
          case 'left center':
            positioning.bottom = (popupDimensions.height - popupDimensions.plusTop - popupDimensions.plusBottom / 2) - (parent.height - parent.plusTop - parent.plusBottom / 2) + 'px';
            positioning.left = -popupDimensions.width + popupDimensions.plusRight + popupDimensions.plusLeft + (parent.width / 2) + 'px';
            break;
          case 'right center':
            positioning.bottom = (popupDimensions.height - popupDimensions.plusTop - popupDimensions.plusBottom / 2) - (parent.height - parent.plusTop - parent.plusBottom / 2) + 'px';
            positioning.left = popupDimensions.width/2 + popupDimensions.plusLeft + 'px';
            break;
          case 'bottom left':
            break;
          case 'bottom center':
            break;
          case 'bottom right':
            positioning.left = -(popupDimensions.width/2) + popupDimensions.plusRight + 'px';
            break;
          default:
            break;
        }
        
        angular.forEach(Object.keys(positioning), function(key){
          popupElement.style[key] = positioning[key];
        });

      });

      //
      // Handle mouse leave
      //
      element.bind('mouseout', function(){
        var element = document.getElementsByClassName(className)[0];
        element.parentNode.removeChild(element);
      });
    }
  }
});